export default function PHP_asinh() {
  return (
    <div>
      <h1>PHP_asinh</h1>
    </div>
  );
}
